const LAYOUT = 'AdsLayout';

export const AsDeporteRouter = [
  {
    path: '/asdeporte',
    name: 'AsdRoot',
    component: () => import('@/views/asdeporte/Events.vue'),
    meta: { layout: LAYOUT }
  },
  {
    path: '/asdeporte/contact',
    name: 'AsdContact',
    component: () => import('@/views/Contact.vue'),
    meta: { layout: LAYOUT }
  },
  {
    path: '/asdeporte/events',
    name: 'AsdEvents',
    component: () => import('@/views/asdeporte/Events.vue'),
    meta: { layout: LAYOUT }
  },
  {
    path: '/asdeporte/events/:id',
    name: 'AsdEvent',
    component: () => import('@/views/events/Show.vue'),
    meta: { layout: LAYOUT }
  }
];